import { render } from "./AvatarSelector.vue?vue&type=template&id=68cf2f2c"
import script from "./AvatarSelector.vue?vue&type=script&lang=js"
export * from "./AvatarSelector.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__